import { fetchJson } from '~/utils/fetch-json-v2';
import { buildQueryString } from '~/utils/query-string';
import type { AccountsQueryParams, BalanceResponse } from '../-types/account';
import type { Transaction } from '../cards/-types/card';

export async function getTransactionsByAccountUrnApi(
  urn: string,
  asset: string,
  direction?: 'in' | 'out',
) {
  const params = new URLSearchParams({ asset });
  if (direction) {
    params.append('direction', direction);
  }

  return fetchJson<{ transactions: Transaction[] }>(
    `/accounts/${urn}/movements?${params.toString()}`,
  );
}

export async function getBalanceByAccountUrnApi(urn: string) {
  return fetchJson<BalanceResponse>(`/accounts/${urn}/balance`);
}

export async function getAccountsApi<T>(params: AccountsQueryParams) {
  const queryString = buildQueryString(params);

  return fetchJson<T>(`/accounts${queryString ? `?${queryString}` : ''}`, {
    method: 'GET',
  });
}

export async function getAccountByUrnApi<T>(urn: string) {
  return fetchJson<T>(`/accounts/${encodeURIComponent(urn)}`, {
    method: 'GET',
  });
}

export async function updateAccountApi(
  urn: string,
  payload: {
    input?: Record<string, unknown>;
    metadata?: Record<string, unknown>;
  },
) {
  return fetchJson(`/accounts/${encodeURIComponent(urn)}`, {
    method: 'PATCH',
    body: payload,
  });
}

export type TransferParams = {
  sourceUrn: string;
  destinationUrn: string;
  amount: string;
  asset?: 'DUSD/6' | 'KSM/12';
  metadata?: Record<string, unknown>;
};

export type TransferResponse = {
  result: {
    queue_id: string;
    status: string;
    message: string;
  };
};

export async function transferApi(params: TransferParams) {
  const asset = params.asset || 'DUSD/6';

  return fetchJson<TransferResponse>(
    `/accounts/${encodeURIComponent(params.sourceUrn)}/transfer`,
    {
      method: 'POST',
      body: {
        destination_account_urn: params.destinationUrn,
        amount: params.amount,
        asset: asset,
        metadata: {
          ...params.metadata,
          source: 'copilot',
        },
      },
    },
  );
}
